import React, { useState, useEffect } from "react";
import { useApp } from "context";
import { Form } from "components";
import { LogoBrand } from "assets/images";
import { Constants, Enums, Helpers, Routes } from "utils";
import { useNavigate, useParams } from "react-router-dom";
import { Typography } from "@mui/material";

export const AccountVerification = () => {
  const { t, user, theme, service, setFeedback } = useApp();
  const navigate = useNavigate();

  const { method } = useParams();
  const authMethod: Enums.EnumAuthMethod | null = Object.values(
    Enums.EnumAuthMethod
  ).includes(method as any)
    ? (method as Enums.EnumAuthMethod)
    : null;

  useEffect(() => {
    !authMethod && navigate(Routes.auth.signin);
  }, []);

  const usePhone = authMethod === Enums.EnumAuthMethod.Phone;

  const [seconds, setSeconds] = useState(Constants.RESEND_CODE_WAITING_TIME);
  const [secondAuthAllowed, setSecondAuthAllowed] = useState(false);
  const [lastAuthIsPhone, setLastAuthIsPhone] = useState(usePhone);

  useEffect(() => {
    if (seconds) {
      const timer = setInterval(
        () => setSeconds((prevSeconds) => prevSeconds - 1),
        1000
      );

      return () => clearInterval(timer);
    } else if (usePhone) {
      setSecondAuthAllowed(true);
    }
  }, [seconds]);

  const { email, phone } = t.message.auth.account_verification;

  const handleResend = async (authMethod: Enums.EnumAuthMethod) => {
    const [status, response] = await service.auth.requestCode(
      user.email,
      { wqp: user.wqp },
      authMethod
    );

    const usePhone = authMethod === Enums.EnumAuthMethod.Phone;

    if (status === Enums.EnumResponse.Success) {
      setFeedback({
        message: usePhone
          ? t.message.auth.sms_resent
          : t.message.auth.email_resent,
        severity: Enums.EnumFeedback.Info,
      });

      setSeconds(Constants.RESEND_CODE_WAITING_TIME);
      setSecondAuthAllowed(false);
      setLastAuthIsPhone(usePhone);
    } else {
      navigate(Routes.auth.signin);
    }
  };

  return (
    <>
      <div className="qh-feedback">
        <div className="qh-wrapper">
          <LogoBrand />
          <div
            className="qh-header"
            style={{ color: theme.palette.font.color }}
          >
            <div className="title">{t.title.auth.account_verification}</div>
            <div className="description">{lastAuthIsPhone ? phone : email}</div>
            <div className="value" style={{ marginBottom: "2rem" }}>
              {lastAuthIsPhone
                ? Helpers.interpolatePhone("XXXXXX" + user.phone)
                : user.email}
            </div>
          </div>
          <div className="qh-content">
            <Form.AccountVerification
              seconds={seconds}
              authMethod={authMethod}
              handleResend={handleResend}
            />
          </div>
        </div>
      </div>
      {secondAuthAllowed && (
        <div className="qh-footer" style={{ right: "inherit" }}>
          <div className="footnote">
            <Typography
              className="link-text"
              onClick={() => handleResend(Enums.EnumAuthMethod.Email)}
              style={{ color: theme.palette.font.color }}
            >
              {t.message.auth.email_instead}
            </Typography>
          </div>
        </div>
      )}
    </>
  );
};
